export const defaultRoute = '/Dashboard'
export const defaultFallbackPath = '/login'
export const defaultPaths = [defaultRoute, '/']
